import moment, { Moment } from "moment";
import { formatInitialPhone } from "../../utils/phonenumbers";

export const CommunicationHistoryAction: { [k: string]: string } = {
  outreach_survey_sent: "Outreach survey sent",
  outreach_survey_response: "Outreach survey recieved",
  patient_message_sent: "SMS sent to patient",
  patient_response_received: "SMS reply from patient",
  family_member_message_sent: "SMS sent to family",
  family_member_response_received: "SMS reply from family",
  secure_message_sent: "Secure message sent",
  video_chat_invite_sent: "Video Visit invitation sent",
  video_chat_completed: "Video Visit completed",
  waiting_room_message_sent: "Waiting room SMS sent to patient",
  waiting_room_reply_received: "Waiting room SMS reply from patient"
};

export interface PatientResponse {
  id: string;
  accountId?: string;
  mrn?: string;
  givenName: string;
  familyName: string;
  dateOfBirth?: string;
  email?: string;
  phone?: string;
  isActive: boolean;
  location?: string;
}

export interface Patient {
  id: string;
  accountId?: string;
  mrn?: string;
  givenName: string;
  familyName: string;
  dateOfBirth?: Moment;
  email?: string;
  phone?: string;
  isActive: boolean;
  location?: string;
}

export interface PatientFormParams {
  givenName: string;
  familyName: string;
  dateOfBirth?: string | null;
  location?: string;
  email?: string;
  phone?: string;
  accountId?: string | null;
  mrn?: string | null;
}

export interface FamilyMemberFormParams {
  name?: string | null;
  relation?: string | null;
  phone?: string | null;
}

export const cleanPatientResponse = (p: PatientResponse): Patient => ({
  ...p,
  dateOfBirth: moment(p.dateOfBirth, "YYYY-MM-DD")
});

export const getPatientFormParams = (p: Patient): PatientFormParams => ({
  givenName: p.givenName,
  familyName: p.familyName,
  dateOfBirth: p.dateOfBirth?.isValid() ? p.dateOfBirth?.format("MM-DD-YYYY") : "",
  location: p.location,
  email: p.email,
  phone: p.phone ? formatInitialPhone(p.phone) : "",
  accountId: p.accountId,
  mrn: p.mrn
});

export interface PatientRequest {
  givenName: string;
  familyName: string;
  dateOfBirth: string | null;
  location?: string;
  email?: string;
  phone?: string;
  accountId?: string | null;
  mrn: string | null;
}

export const getPatientFormParamsRequest = (p: PatientFormParams): PatientRequest => ({
  ...p,
  // These need to be null to avoid unique_together constraints on the server
  mrn: p.mrn || null,
  accountId: p.accountId || null,
  dateOfBirth: p.dateOfBirth ? moment(p.dateOfBirth, "MM-DD-YYYY").format("YYYY-MM-DD") : null
});
